/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Date: 8/10/21
 * Copyright All Rights Reserved
 */

const getParamsString = params => Object.keys(params).map(key => `${key}=${params[key]}`).join('&');

export default getParamsString;



// WEBPACK FOOTER //
// ./js/support/getParamsString.js